export default "__VITE_ASSET__D90BOo45__"